// ======================================================================
// File Name       : AccountAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { LO_SUPER_USER, SUPER_USER, MODE, MESSAGE_TYPE } from '../constants';
import * as userRequests from './httpRequests/user';
import * as superUserRequest from './httpRequests/superuser';
import * as superUserActions from './SuperUserAction';
import * as userActions from './UserAction';
import { UPDATE_AUTH_USER_INFO } from '../constants/ActionTypes';
import { updateUserInfo } from './actionCreators/user';
import { SHOW_MESSAGE } from '../constants/actionTypes/message';
import { SUPERUSER_LOGIN_TYPE } from '../constants/CommonConstants';

export function saveAccount({ loginId, userName, currentPassword, password, mailAddress }) { // Step10.0.0
  return async (dispatch, getState) => {
    const { userInfo, enterpriseCd } = getState().authed.authedUser;
    const { userSecernId, displayUserType } = userInfo;
    const { integrationUser } = getState().user;
    if (isSuperUser(displayUserType)) {
      // STEP 12.0.0 START
      if ((integrationUser && Object.keys(integrationUser).length)
        || userInfo.superuserType === SUPERUSER_LOGIN_TYPE.INTEGRATION_ROOT_SUPERUSER
      ) {
        const integrationUserInfo = {
          integrationUserSecernId: userSecernId,
          integrationUserName: userName || userInfo.userName,
          loginId: loginId || userInfo.loginId,
          currentPassword,
          password,
        };
        await superUserRequest.postIntegrationUserEdit({
          editType: MODE.EDIT_MODE,
          integrationUserInfo,
        });
        integrationUserInfo.userName = integrationUserInfo.integrationUserName;
        await dispatch(updateUserInfo(integrationUserInfo));
        dispatch(showSuccessMessage());
      } else {
        const superuserInfo = {
          superuserSecernId: userSecernId,
          superuserName: userName || userInfo.userName,
          loginId: loginId || userInfo.loginId,
          relationEnterpriseCd: enterpriseCd,
          currentPassword: currentPassword,
          afterPassword: password,
          mailAddress: mailAddress,
        };
        await superUserRequest.postSuperUserEdit({
          editType: MODE.EDIT_MODE,
          superuserInfo,
        });
        superuserInfo.userName = superuserInfo.superuserName;
        await dispatch(updateUserInfo(superuserInfo));
        dispatch(showSuccessMessage());
      }
      // STEP 12.0.0 END
    } else {
      const userInfoToUpdate = {
        userSecernId,
        userName: userName || userInfo.userName,
        loginId: loginId || userInfo.loginId,
        afterPassword: password,
        mailAddress: mailAddress || userInfo.mailAddress , // Step10.0.0
      };
      await userRequests.postUserEdit({
        editType: MODE.EDIT_MODE,
        userInfo: userInfoToUpdate,
      });
      await dispatch(updateUserInfo(userInfoToUpdate));
      dispatch(showSuccessMessage());
    }
  };
}

function showSuccessMessage() {
  return (dispatch) => {
    const messageInfo = {
      message: ['編集が完了しました'],
    };
    messageInfo.messageType = MESSAGE_TYPE.success;
    dispatch({ type: SHOW_MESSAGE, ...messageInfo });
  };
}

export function fetchAccount() {
  return async (dispatch, getState) => {
    const { userInfo } = getState().authed.authedUser;
    const { userSecernId, displayUserType } = userInfo;

    if (!isSuperUser(displayUserType)) {
      dispatch(
        userActions.fetchUser({
          searchInfo: {
            userSecernIdList: [userSecernId],
          },
        }),
      );
    }
  };
}

export function isSuperUser(displayUserType) {
  return [LO_SUPER_USER, SUPER_USER].indexOf(displayUserType) > -1;
}
